import { toast } from "react-toastify";
import i18n from "../i18n/i18n";

export function* handleError(error: any) {
  if (error?.response?.status === 401 || error?.status === 401) {
    window.location.href = "/login";
  }
  if (error?.response?.status === 403 || error?.status === 403) {
    toast.error(String(i18n.t("forbidden.accessDenied")));
    return;
  }

  let msg = (error as Error).message;
  let name = (error as Error).name;
  if (name === undefined || msg === undefined) {
    //Here the error comes from the globalexceptionhandler it is a promise and needs to be handled
    error.json().then(function (result: any) {
      toast.error(result.error + ": " + result.messages);
    });
  } else {
    toast.error(msg);
  }
}

export function getSuccessToast(message: any) {
  toast.success(message);
}
